module.exports = __webpack_public_path__ + "assets/img/Logitech-PW-Australia-Landing-page.01ceab04.webp";